import styles from './flags.less'; export {styles};

export interface FlagData {
    store: number,
    active: boolean;
    image: string;
    url: string;
}

interface FlagsProps {
    flags: FlagData[];
}

export default class Flags extends React.PureComponent<FlagsProps, null> {

    render() {
        return (
            <div className={styles.flags}>
                {this.props.flags.map((flag, idx) =>
                    <div className={classNames(styles.flag, {[styles.active]: flag.active})} key={idx}>
                        <a href={flag.active ? '#' : flag.url}>
                            <img src={flag.image}/>
                        </a>
                    </div>
                )}
            </div>
        );
    }
}
